import { useEffect, useRef } from 'react';

function GrainOverlay() {
    const canvasRef = useRef(null);
    const videoRef = useRef(null);

    useEffect(() => {
        const canvas = canvasRef.current;
        const video = videoRef.current;
        if (!canvas || !video) return;

        const ctx = canvas.getContext('2d');
        let animId;
        let playing = false;

        function resize() {
            canvas.width = window.innerWidth;
            canvas.height = window.innerHeight;
        }

        function draw() {
            if (playing) {
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
            }
            animId = requestAnimationFrame(draw);
        }

        function tryPlay() {
            if (playing) return;
            video.play().then(() => {
                playing = true;
                canvas.style.opacity = '1.0';
                draw();
            }).catch(() => {
                canvas.style.display = 'none';
            });
        }

        resize();
        window.addEventListener('resize', resize);
        video.addEventListener('canplay', tryPlay);
        video.addEventListener('loadeddata', tryPlay);

        function onInteraction() {
            tryPlay();
            document.removeEventListener('touchstart', onInteraction);
            document.removeEventListener('click', onInteraction);
        }
        document.addEventListener('touchstart', onInteraction);
        document.addEventListener('click', onInteraction);

        return () => {
            cancelAnimationFrame(animId);
            window.removeEventListener('resize', resize);
            document.removeEventListener('touchstart', onInteraction);
            document.removeEventListener('click', onInteraction);
        };
    }, []);

    return (
        <>
            <video
                ref={videoRef}
                src="/media/grain-overlay.mp4"
                loop
                muted
                playsInline
                preload="auto"
                aria-hidden="true"
                style={{
                    position: 'fixed',
                    width: '1px',
                    height: '1px',
                    opacity: 0,
                    pointerEvents: 'none',
                    zIndex: -1,
                }}
            />
            <canvas
                ref={canvasRef}
                className="grain-overlay"
                aria-hidden="true"
                style={{ opacity: 0 }}
            />
        </>
    );
}

export default GrainOverlay;
